import apis from '@/apis'

export default {
    state: {
        selectDeptInfo:{},
        startdate:"",
        enddate:"",
        type:"",
        selectSource:{},
        selectDoctor:{},
        registOutput:{},
        registOrderInput:{},
        registOrderOutput:{}
    },
    actions: {
        changeSelectDeptInfo:(context,para)=>{
            context.commit('changeSelectDeptInfo',para)
        },

        changeRegistStartdate:(context,para)=>{
            context.commit('changeRegistStartdate',para)
        },

        changeRegistType:(context,para)=>{
            context.commit('changeRegistType',para)
        },

        changeRegistEnddate:(context,para)=>{
            context.commit('changeRegistEnddate',para)
        },

        changeRegistSelectSource:(context,para)=>{
            context.commit('changeRegistSelectSource',para)
        },

        changeRegistSelectDoctor:(context,para)=>{
            context.commit('changeRegistSelectDoctor',para)
        },

        changeRegistOutput:(context,para)=>{
            context.commit('changeRegistOutput',para)
        },

        clearRegistSource:(context)=>{
            context.commit('clearRegistSource')
        },

        clearRegistAll:(context)=>{
            context.commit('clearRegistAll')
        },

        changeRegistOrderInput:(context,para)=>{
            context.commit('changeRegistOrderInput',para)
        },

        changeRegistOrderOutput:(context,para)=>{
            context.commit('changeRegistOrderOutput',para)
        }


        
    },
    mutations: {
        changeSelectDeptInfo:(state,para)=>{
            state.selectDeptInfo =   para  
        },

        changeRegistStartdate:(state,para)=>{
            state.startdate =   para  
        },

        changeRegistEnddate:(state,para)=>{
            state.enddate =   para  
        },

        changeRegistType:(state,para)=>{
            state.type =   para  
        },

        changeRegistSelectSource:(state,para)=>{
            state.selectSource =   para  
        },

        changeRegistSelectDoctor:(state,para)=>{
            state.selectDoctor =   para  
        },

        changeRegistOutput:(state,para)=>{
            state.registOutput =   para  
        },

        changeRegistOrderInput:(state,para)=>{
            state.registOrderInput =   para  
        },

        changeRegistOrderOutput:(state,para)=>{
            state.registOrderOutput =   para  
        },

        clearRegistSource:(state)=>{
            if (JSON.stringify(state.registOrderOutput) != '{}') {
                if (JSON.stringify(state.registOutput) == '{}') {
                    const m2005input={
                        patientid: state.registOrderInput.patientid,
                        lockid: state.registOrderOutput.output.lockid,
                        schemaid: state.registOrderInput.schemaid,
                        dept_code: state.registOrderInput.dept_code,
                        regtype:state.registOrderInput.regtype
                    }

                    apis.request_pro('2005',m2005input).then(res =>{  
                        console.log(res.outPut); 
                        state.selectSource = {}
                    })
                    

                }
            }
        },

        clearRegistAll:(state)=>{
            if (JSON.stringify(state.registOrderOutput) != '{}') {
                if (JSON.stringify(state.registOutput) == '{}') {
                    const m2005input={
                        patientid: state.registOrderInput.patientid,
                        lockid: state.registOrderOutput.output.lockid,
                        schemaid: state.registOrderInput.schemaid,
                        dept_code: state.registOrderInput.dept_code,
                        regtype:state.registOrderInput.regtype
                    }

                    apis.request_pro('2005',m2005input).then(res =>{  
                        console.log(res.outPut); 
                        state.selectSource = {}
                    })
                    

                }
            }
            
            state.selectDeptInfo={}
            state.startdate="",
            state.enddate="",
            state.selectSource={}
            state.selectDoctor={}
            state.registOutput={}
            state.registOrderInput={}
            state.registOrderOutput={}
        }

        
    }
}